import styled from 'styled-components';

export const ListContainer = styled.ul`
  margin-right: ${props => props.theme.space['8.0']};
  ${props => props.theme.mediaQueries.mediumDown} {
    margin-right: ${props => props.theme.space.none};
  }
`;

export const ListItemContainer = styled.li`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: ${props => props.theme.space['1.0']};
  &:last-child {
    margin-bottom: ${props => props.theme.space.none};
  }
`;

export const ListItemImage = styled.img`
  ${props => props.theme.mediaQueries.smallDown} {
    max-width: ${props => props.theme.space.s8};
  }
`;

export const ListItemText = styled.span`
  color: ${props => props.theme.colors.white} !important;
  font-style: normal !important;
  font-family: ${props => props.theme.fonts.circular} !important;
  font-weight: ${props => props.theme.fontWeights.semiBold} !important;

  letter-spacing: ${props => props.theme.letterSpacings.normal} !important;
  line-height: ${props => props.theme.lineHeights.headerThree} !important;

  padding: 0 0 0 ${props => props.theme.space['5.0']} !important;
  font-size: ${props => props.theme.fontSizes.headerThree} !important;
  ${props => props.theme.mediaQueries.smallDown} {
    padding: 0 0 0 ${props => props.theme.space['3.0']} !important;
    font-size: ${props => props.theme.fontSizes.body} !important;
  }

  margin: 0 !important;
`;
